<template>
  <div>
    <div v-if="isReferee" class="title">
      Решение спора в матче #{{ match.id }}
    </div>
    <div v-else-if="isBoType1" class="title">Указать победителя</div>
    <div v-else class="title">Указать счёт</div>

    <div class="divider"></div>
    <div class="match-result">
      <p v-if="isReferee">
        Выберите <span>одно из&nbsp;действий</span> в&nbsp;отношении участников
        матча. Вы&nbsp;можете присудить победу,
        <span>продвинув игрока</span> дальше по&nbsp;турнирной сетке, либо
        объявить <span>техническое поражение</span> обоим игрокам.
      </p>
      <p v-else-if="isBoType1">Выберите <span>победителя</span> матча</p>
      <p v-else>Укажите счёт <span>игры</span></p>

      <div class="teams">
        <div class="team">
          <div class="tournament__member team_red">
            <div class="tournament__member_info">
              <div class="tournament__member_name ellipsis">
                {{ (match.player1 && match.player1.nickname) || "Пустой слот" }}
              </div>
            </div>
            <div class="tournament__member__ava tournament__member__ava_red">
              <img
                v-if="match.player1 && match.player1.avatar"
                :src="match.player1.avatar"
                alt="avatar"
              />
              <SvgIcon v-else size="80%" name="user-light" />
            </div>
          </div>
          <app-btn
            v-if="isReferee"
            :disabled="!!loadingPlayer && loadingPlayer !== 1"
            :loading="loadingPlayer === 1"
            color="red-grad"
            class="team-action"
            @click.stop="sendProtestResult(1)"
          >
            <span class="hidden-xs-only">Продвинуть игрока</span>
            <span class="hidden-sm-and-up">Продвинуть</span>
          </app-btn>
          <app-btn
            v-else-if="isReferee && !match.player1"
            disabled
            color="red-grad"
            class="team-action"
          >
            <span class="hidden-xs-only">Игрок отсутствует</span>
            <span class="hidden-sm-and-up">Отсутствует</span>
          </app-btn>
          <app-btn
            v-else-if="isBoType1"
            :disabled="loadingPlayer === 2"
            :loading="loadingPlayer === 1"
            color="blue-grad"
            class="team-action"
            @click.stop="confirmResult(1, 0)"
          >
            <span class="hidden-xs-only">Подтвердить выбор</span>
            <span class="hidden-sm-and-up">Выбрать</span>
          </app-btn>

          <input
            v-else
            type="text"
            class="team-action form-input"
            v-mask="'#'"
            v-model="player1_score"
          />
        </div>
        <div class="teams-divider"></div>
        <div class="team">
          <div class="tournament__member team_blue">
            <div class="tournament__member_info">
              <div class="tournament__member_name ellipsis">
                {{ (match.player2 && match.player2.nickname) || "Пустой слот" }}
              </div>
            </div>
            <div class="tournament__member__ava tournament__member__ava_blue">
              <img
                v-if="match.player2 && match.player2.avatar"
                :src="match.player2.avatar"
                alt="avatar"
              />
              <SvgIcon v-else size="80%" name="user-light" />
            </div>
          </div>
          <app-btn
            v-if="isReferee && match.player2"
            :disabled="!!loadingPlayer && loadingPlayer !== 2"
            :loading="loadingPlayer === 2"
            color="blue-grad"
            class="team-action"
            @click.stop="sendProtestResult(2)"
          >
            <span class="hidden-xs-only">Продвинуть игрока</span>
            <span class="hidden-sm-and-up">Продвинуть</span>
          </app-btn>
          <app-btn
            v-else-if="isReferee && !match.player2"
            disabled
            color="blue-grad"
            class="team-action"
          >
            <span class="hidden-xs-only">Игрок отсутствует</span>
            <span class="hidden-sm-and-up">Отсутствует</span>
          </app-btn>
          <app-btn
            v-else-if="isBoType1"
            :disabled="loadingPlayer === 1"
            :loading="loadingPlayer === 2"
            color="blue-grad"
            class="team-action"
            @click.stop="confirmResult(0, 1)"
          >
            <span class="hidden-xs-only">Подтвердить выбор</span>
            <span class="hidden-sm-and-up">Выбрать</span>
          </app-btn>

          <input
            v-else
            type="text"
            class="team-action form-input"
            v-mask="'#'"
            v-model="player2_score"
          />
        </div>
      </div>
    </div>
    <div class="match-result__action">
      <app-btn
        v-if="isReferee"
        :disabled="!!loadingPlayer && loadingPlayer !== 3"
        :loading="loadingPlayer === 3"
        color="orange-grad px-5"
        @click.stop="sendProtestResult(3)"
      >
        <span>Тех. поражение</span>
      </app-btn>
      <app-btn
        v-else-if="!isBoType1"
        :loading="!!loadingPlayer"
        color="yellow-grad px-4"
        @click.stop="confirmResult(player1_score, player2_score)"
      >
        <span>Отправить счёт</span>
      </app-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import matchService from "@/services/match";
import showAlert from "@/services/common/showAlert";
import showConfirm from "@/services/common/showConfirm";
import { VueMaskDirective } from "v-mask";

const scoresByBoType = {
  1: 1,
  2: 2,
  3: 3
};

export default {
  name: "MatchResultModal",
  directives: { mask: VueMaskDirective },
  props: {
    scores: {
      type: Object,
      required: true
    },
    match: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loadingPlayer: 0,
      player1_score: +this.scores.player1 || 0,
      player2_score: +this.scores.player2 || 0
    };
  },

  computed: {
    ...mapGetters("auth", ["isReferee"]),

    boType() {
      return this.match.format || 1;
    },

    maxScore() {
      return scoresByBoType[this.boType] || Infinity;
    },

    isBoType1() {
      return this.boType === 1;
    }
  },

  watch: {
    player1_score(after) {
      this.player1_score = Math.min(after, this.maxScore);
    },
    player2_score(after) {
      this.player2_score = Math.min(after, this.maxScore);
    }
  },

  methods: {
    async sendProtestResult(side) {
      if (this.loadingPlayer) return;
      this.loadingPlayer = side;

      let question =
        "Вы уверены, что хотите объявить <b>техническое поражение</b> обоим игрокам?";

      if ([1, 2].includes(side)) {
        let { [`player${side}`]: player } = this.match;

        question = `Вы уверены, что хотите присудить победу в пользу <b>${player.nickname}</b> и продвинуть его дальше?`;
      }

      let confirmed = await showConfirm(question, "Продолжить");
      let data = null;

      if (confirmed) {
        data = await this.submitRefereeAction(side);
        this.$modals.close();
      }

      this.loadingPlayer = 0;

      this.$nextTick(() => {
        if (data && data.message) showAlert(data.message, 2500);
      });
    },

    async submitRefereeAction(side) {
      if (side === 3) {
        return await matchService.setTechLoose(this.match.id);
      } else if ([1, 2].includes(side)) {
        return await matchService.promoteTeam(this.match.id, side);
      }

      return null;
    },

    async confirmResult(player1_score, player2_score) {
      if (this.loadingPlayer) return;
      this.loadingPlayer = player1_score > player2_score ? 1 : 2;

      let data = await matchService.sendScore(this.match.id, {
        player1_score,
        player2_score
      });

      this.$modals.close();
      this.loadingPlayer = 0;

      this.$nextTick(() => {
        if (!data.success && data.message) showAlert(data.message, 2500);
      });
    }
  }
};
</script>

<style lang="scss">
.match-result {
  > p {
    span {
      color: #fbc33e;
      font-weight: bold;
    }
  }

  text-align: center;

  &__action {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }

  .teams,
  .team-action {
    margin-top: 30px;

    &.form-input {
      width: 40%;
      padding: 8px 16px;
      border-radius: 100px;
      text-align: center;

      @include text-color(#fff);

      background: rgba(#000a25, 0.6);
      border: 1px solid rgba(#000a25, 0.6);

      outline: none;
      font-size: 25px;
      line-height: 108.95%;
      transition: $secondary-transition;

      &:focus {
        border-color: #1480b2;
      }
    }
  }

  .team {
    @include breakpoint("xs-only") {
      padding: 0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
    }
  }

  .teams {
    display: flex;
    justify-content: space-around;

    &-divider {
      width: 1px;
      background: rgba(#fff, 0.2);
      margin: 0 16px;
    }

    @include breakpoint("xs-only") {
      margin-top: 20px;
      display: flex;
      align-items: center;
      flex-direction: row;
      flex-wrap: wrap;
      > * {
        flex: 1 1 auto;
      }

      &-divider {
        height: 1px;
        width: 100%;
        margin: 20px 0;
      }
    }

    .tournament__member {
      margin: 0 auto;

      @include breakpoint("xs-only") {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        // flex-wrap: wrap;
        margin: 0;
      }

      &_name {
        text-align: center;

        @include breakpoint("xs-only") {
          max-width: 75px;
          text-align: left;
        }
      }

      &__ava,
      &_info {
        @include breakpoint("xs-only") {
          flex: 1 1 auto;
        }
      }

      &__ava {
        @include breakpoint("xs-only") {
          margin-right: 8px !important;
          margin-top: 0 !important;
          height: 50px;
          min-width: 50px;
          max-width: 50px;
          order: 1;
        }
      }

      &_info {
        width: 100%;

        @include breakpoint("xs-only") {
          order: 2;
        }
      }
    }
  }

  .team-action {
    @include breakpoint("xs-only") {
      margin-top: 0;
    }
  }
}
</style>
